@if (hasFieldAverage()) {
  <span class="text-muted-color text-sm">
    {{
      'project.steps.providerResults.rfpIndividual.fieldAverage' | transloco: fieldAverageParams()
    }}
  </span>
}
@for (subCriterion of criterion().subCriteria; track subCriterion.scNumber) {
  <div class="grid grid-cols-[minmax(0,1fr)_8rem_4rem] items-center gap-3 text-sm">
    <span class="flex flex-col">
      <span>{{ subCriterion.label }}</span>
      @if (subCriterion.weight !== null) {
        <span class="text-muted-color text-xs" data-testid="rfp-individual-sub-criterion-weight">
          {{ 'project.steps.providerResults.weight' | transloco }}:
          {{ subCriterion.weight * 100 | appNumber: '1.0-2' }} %
        </span>
      }
    </span>
    @if (subCriterion.percentage !== null) {
      <app-score-bar [percentage]="subCriterion.percentage" />
      <span class="text-right font-semibold"
        >{{ subCriterion.percentage | appNumber: '1.0-0' }} %</span
      >
    } @else {
      <span></span>
      <span class="text-muted-color text-right">{{
        'project.steps.providerResults.rfpIndividual.notEvaluated' | transloco
      }}</span>
    }
  </div>
}
